export default __webpack_public_path__ + "static/media/EmployeeDirectory.10cb782d.png";